import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers'
import dateUtils from 'shared/src/date'

const DatePickerUI = ({
  label = "Click to change the date",
  value,
  disablePast,
  shouldDisableDate,
  min,
  max,
  className,
  onChange,
}) => {
  return (
    <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <DatePicker
        format="dd/MM/yyyy"
        disablePast={ disablePast }
        shouldDisableDate={ shouldDisableDate }
        minDate={ min ? dateUtils.getDate(min) : null }
        maxDate={ max ? dateUtils.getDate(max) : null }
        className={ className }
        label={ label }
        value={ value }
        onChange={ onChange }
        animateYearScrolling
      />
    </MuiPickersUtilsProvider>
  )
}

export default DatePickerUI